<template>
    <DashView>
        <div class="container-fluid pt-4 px-4 pb-5 mb-5">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <!-- <h5 class="mb-0">{{dossiers.code_dossier}}</h5> -->
                <div class="row ">
                    <h6><u>{{dossiers.code_dossier}}</u></h6>
                    <small>{{dossiers.prenom_patient}} <b> {{dossiers.nom_patient}}</b> <br>
                    <b>{{ dossiers.sexe === 1 ? 'Male' : 'Femelle' }}</b>, Âgé de {{ age.years }} ans{{ age.days > 0 ? ' ' + age.days + ' jour' + (age.days > 1 ? 's' : '') : '' }}</small>
                    <br><br><div v-if="dossiers.tension || dossiers.temperature || dossiers.poids || dossiers.sucre || dossiers.taille" class="fst-italic">
                        <span v-if="dossiers.groupe_sanguin">&nbsp; <u>Groupe Sanguin</u> : <b>{{ dossiers.groupe_sanguin }}</b></span>
                        <span v-if="dossiers.tension">&nbsp; &nbsp;<u>Tension artérielle</u> : <b>{{ dossiers.tension }} mmHg</b></span>&nbsp;
                        <span v-if="dossiers.temperature">&nbsp; &nbsp; <u>Température</u> : <b>{{ dossiers.temperature }} °C</b></span>&nbsp;
                        <span v-if="dossiers.poids"> &nbsp; &nbsp;<u>Poids</u> : <b>{{ dossiers.poids }} kg</b></span>&nbsp;
                        <span v-if="dossiers.sucre"> &nbsp; &nbsp;<u>Sucre</u> : <b>{{ dossiers.sucre }} g/L</b></span>&nbsp;
                        <span v-if="dossiers.taille">&nbsp; &nbsp; <u>Taille</u> : <b>{{ dossiers.taille }} cm</b></span>
                    </div>

                </div>
                <button id="closeBtn" v-if="dossiers.dossier_status==1 &role==3" data-bs-toggle="modal" data-bs-target="#closeModal" class="btn" style="background-color: #00C853; color: #fff;">
                    <i class="fas fa-check-circle" style="color: #fff;"></i> Terminer la consultation
                </button>
                <button id="closeBtn" v-if="dossiers.dossier_status==1 &role==4" data-bs-toggle="modal" data-bs-target="#preliminaire-consul" class="btn" style="background-color: #00C853; color: #fff;">
                    <i class="fas fa-check-circle" style="color: #fff;"></i> Ajouter Données préliminaires
                </button>
            </div>
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                        <div class="row justify-content-center">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header">
                                        <ul class="nav nav-tabs card-header-tabs" id="myTab"
                                            role="tablist">                                                
                                                <li class="nav-item" v-if="role==3 && dossiers.declasser==1">
                                                    <a class="nav-link active" id="tab1-tab"
                                                        data-bs-toggle="tab" href="#tab1" role="tab"
                                                        aria-controls="tab1" aria-selected="false">
                                                        Nouvelle Consultation
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="nav-link" id="tab2-tab"
                                                    data-bs-toggle="tab" href="#tab2" role="tab"
                                                    aria-controls="tab2" aria-selected="false" @click="loadHistoriqueConsultation">
                                                    Historiques
                                                    </a>
                                                </li>
                                                <!-- <li class="nav-item">
                                                    <a class="nav-link text-primary" id="tab3-tab"
                                                    data-bs-toggle="tab" href="#tab3" role="tab"
                                                    aria-controls="tab3" aria-selected="false">
                                                    Autres
                                                    </a>
                                                </li> -->
                                                <li class="nav-item">
                                                    <a :class="['nav-link', { 'active': role != 3 || dossiers.declasser !=1 }]" id="tab4-tab"
                                                    data-bs-toggle="tab"
                                                    href="#tab4" role="tab"
                                                    aria-controls="tab4" aria-selected="false">
                                                    Patient
                                                    </a>
                                                </li>
                                            </ul>
                                    </div>
                                    <div class="card-body">
                                        <div class="tab-content" id="myTabContent">
                                            <div :class="['tab-pane', 'fade', 'show', '', { 'active': role === 3 && dossiers.declasser==1  }]" id="tab1"
                                                    role="tabpanel" aria-labelledby="tab1-tab">
                                                    
                                                   <div class="col-lg-12 col-md-12 col-sm-12 mb-4" v-if="dossiers?.docteur_id">
                                                        <div class="row " v-if="validationErrors.length>0">
                                                            <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                                                <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                                    <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <p v-if="success_msg" class="text-white alert text-center text-info">{{ success_msg }}</p>
                                                    
                                                        <!-- Première partie - Informations de consultation -->
                                                         <div class="row w-100 g-3 mb-3"> <!-- g-0 pour supprimer les gutters -->
                                                                <!-- Colonne Symptômes/Remarques -->
                                                                <div class="col-lg-8 col-md-8 col-sm-12 pe-5"> <!-- pe-1 pour un petit espace -->
                                                                    <div class="p-2 border rounded h-100" style="min-height: 100px; overflow-y: auto; font-size: 20px;">
                                                                        <!-- Symptômes -->
                                                                    <div v-for="(symptome, index) in panier_symptome" :key="'symptome-' + index">
                                                                        <span class="badge bg-light text-dark mb-1 badge-hover-close removefont">
                                                                        {{ symptome.contenu }}
                                                                        <i class="fa fa-times ms-1 btn-close" style="cursor: pointer; color: red;" @click="removeFromCart('symptomes', index)"></i>
                                                                        </span><br>
                                                                    </div>

                                                                    <!-- Remarques -->
                                                                    <div v-for="(element, index) in panier_remarque" :key="'remarque-' + index">
                                                                        <span class="fst-italic badge-hover-close removefont" style="font-size: 15px">
                                                                        {{ element.remarque }}
                                                                        <i class="fa fa-times ms-1 btn-close" style="cursor: pointer; color: red;" @click="removeFromCart('remarques', index)"></i>
                                                                        </span><br>
                                                                    </div>

                                                                    <!-- Notes -->
                                                                    <div v-for="(note, index) in panier_note" :key="'note-' + index">
                                                                        <span class="fst-italic bg-yellow badge-hover-close removefont" style="background-color: yellow; font-size: 12px;">
                                                                        {{ note.note }}
                                                                        <i class="fa fa-times ms-1 btn-close" style="cursor: pointer; color: red;" @click="removeFromCart('notes', index)"></i>
                                                                        </span>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                <!-- Colonne Prescription - Version compacte -->
                                                                <div class="col-lg-4 col-md-4 col-sm-12"> <!-- ps-1 pour équilibrer -->
                                                                    <div class="card h-100 border-0"> <!-- border-0 pour plus de légèreté -->
                                                                        <div class="card-header p-1 bg-white border-bottom"> <!-- En-tête compact -->
                                                                            <h6 class="mb-0 fw-bold">Prescriptions</h6> <!-- h6 plus petit -->
                                                                        </div>
                                                                        <div class="card-body p-1"> <!-- Corps compact -->
                                                                            <form id="prescription" @submit.prevent="addPrescriptionInCart">
                                                                                <!-- Champs compacts -->
                                                                                <div class="mb-1">
                                                                                    <label class="d-block small">Médicament</label>
                                                                                    <input type="text" class="form-control form-control-sm" v-model="form.prescription.medicament">
                                                                                </div>
                                                                                <div class="mb-1">
                                                                                    <label class="d-block small">Posologie</label>
                                                                                    <input type="text" class="form-control form-control-sm" v-model="form.prescription.posologie">
                                                                                </div>
                                                                                <button class="btn btn-sm btn-success w-100 mb-1 py-0" @click="addPrescriptionInCart">Ajouter</button>
                                                                            </form>
                                                                            <div class="detail-section" v-if="panier_prescription.length>0">
                                                                                <h5 style="color: #00C853; text-decoration: underline;">Prescriptions</h5>
                                                                                <div class="table-responsive">
                                                                                    <table class="table table-sm table-hover align-middle">
                                                                                    <thead class="table-light">
                                                                                        <tr>
                                                                                        <th>#</th>
                                                                                        <th>Médicament</th>
                                                                                        <th>Posologie</th>
                                                                                        <th>Action</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr v-for="(element, key) in panier_prescription" :key="key">
                                                                                        <td>{{ key + 1 }}</td>
                                                                                        <td>{{ element.medicament }}</td>
                                                                                        <td>{{ element.posologie }}</td>
                                                                                        <td>
                                                                                            <button class="btn btn-sm btn-outline-danger" @click="removeFromCart('prescription', key)">
                                                                                            <i class="fa fa-trash"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                    </table>
                                                                                </div>                                                                               
                                                                            </div>
                                                                            <form id="examen" @submit.prevent="addExamenInCart">
                                                                                <div class="mb-3">
                                                                                        <label for="symptomSelect" class="form-label fw-bold">Examens</label>
                                                                                        <input type="text" class="form-control" v-model="form.examen.nom">
                                                                                </div>

                                                                                <div class="mb-3">
                                                                                    <button type="submit" style="color: #fff;" class="btn btn-sm btn-success w-100 mb-1 py-0 btn" id="addSymptomBtn">Ajouter</button>
                                                                                </div>
                                                                            </form>

                                                                        <div class="detail-section" v-if="panier_examen.length>0">
                                                                                <h5 style="color: #00C853; text-decoration: underline;">Examens</h5>
                                                                                <div v-for="(examen,key) in panier_examen" :key="key">
                                                                                    <div class="symptom-tag" style="font-size: 14px;">{{ examen.nom }} 
                                                                                        <i class="fa fa-remove text-danger remove-icon" @click="removeFromCart('examen',key)"></i>
                                                                                    </div>
                                                                                </div>                                                                               
                                                                        </div>                                                                        
                                                                    <!-- </form> -->
                                                                                
                                                                                <!-- Liste compacte -->
                                                                                <!-- <div class="mt-1 small">
                                                                                    <div class="d-flex justify-content-between border-top pt-1">
                                                                                        <span>Paracétamol : 500mg 3x/jour</span>
                                                                                        <i class="fas fa-times text-danger"></i>
                                                                                    </div>
                                                                                </div> -->
                                                                            <!-- </form> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                         </div>

                                                        
                                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Symptomes</button>
                                                            </li>
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Remarques</button>
                                                            </li>
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">Notes</button>
                                                            </li>
                                                     </ul>
                                                <!-- Contenu  -->
                                            <div class="tab-content" id="myTabContent">
                                                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                            <form id="symptome" @submit.prevent="addSymptomeInCart">
                                                                <div class="row mt-3">
                                                                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                                                        <!-- <label for="remarque" class="form-label">Remarques</label> -->
                                                                        <textarea class="form-control" v-model="form.symptome.contenu" id="remarque" rows="4" @keydown.enter.prevent="addSymptomeInCart"></textarea>
                                                                    </div>
                                                                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                                                        <button type="submit" style="margin-top: 20%;" class="btn btn-round btn-success" id="remarque">Ajouter</button>
                                                                    </div>
                                                                </div>           
                                                            </form>
                                                    </div>
                                                    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                                        <!-- <div class=""> -->
                                                            <form id="consultationInfoForm" @submit.prevent="addRemarqueInCart"  ref="fremarque">
                                                                <div class="row mt-3">
                                                                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                                                        <!-- <label for="remarque" class="form-label">Remarques</label> -->
                                                                        <textarea class="form-control" v-model="form.consultation.remarque" id="remarque" rows="4" @keydown.enter.prevent="addRemarqueInCart"></textarea>
                                                                    </div>
                                                                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                                                        <button type="submit" style="margin-top: 20%;" class="btn btn-round btn-success" id="remarque">Ajouter</button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            
                                                        <!-- </div> -->
            
                                                            </div>
                                                        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                                            <!-- Form Note         -->
                                                            <form @submit.prevent="addNoteInCart"  ref="fnote">
                                                                            <div class="row mt-3">
                                                                                <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                                                                    <!-- <label for="remarque" class="form-label">Remarques</label> -->
                                                                                    <textarea class="form-control" v-model="form.consultation.note" id="remarque" rows="4" @keydown.enter.prevent="addNoteInCart"></textarea>
                                                                                </div>
                                                                                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                                                                    <button type="submit" style="margin-top: 20%;" class="btn btn-round btn-success" id="note">Ajouter</button>
                                                                                </div>
                                                                            </div>
                                                                    </form>
                                                        </div>
                                                    </div>
                                                
                                                    <div class="col-12 mt-1 gap-2">
                                                        <button 
                                                            type="button" 
                                                            class="btn btn-sm btn-info float-end" 
                                                            style="color: #fff;" 
                                                            id="addSymptomBtn" 
                                                            @click="registerConsultation"
                                                        >
                                                            Enrégistrer
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            class="btn btn-sm btn-danger float-left" 
                                                            @click="cancelConsultation"
                                                        >
                                                            Annuler
                                                        </button>
                                                    </div>


                                                    </div>
                                                    <div v-else class="d-flex justify-content-center align-items-center">
                                                        <div class="custom-alert d-flex justify-content-between align-items-center p-3 rounded shadow-sm w-100" style="max-width: 500px;">
                                                            <div class="d-flex align-items-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="24" height="24" fill="white" viewBox="0 0 24 24">
                                                                <path d="M12 2C6.477 2 2 6.478 2 12s4.477 10 10 10 10-4.478 10-10S17.523 2 12 2zm.5 14h-1v-1h1v1zm0-3h-1V7h1v6z"/>
                                                            </svg>
                                                            <span class="fw-semibold text-white">Je prends la main !</span>
                                                            </div>
                                                            <button type="button" @click="confirmerPriseDeMain" class="btn btn-light btn-sm fw-bold px-3">
                                                            Confirmer
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tab-pane fade" id="tab2" role="tabpanel"
                                                    aria-labelledby="tab2-tab">
                                                    <div class="row pb-5 mb-5">
                                                        <div class="accordion">
                                                            <!-- Consultation 1 -->
                                                            <template v-if="listHistorique.length>0">
                                                                <div v-for="(histo,key) in historiques" :key="key">
                                                                    
                                                                        <div class="accordion-item" >
                                                                        <h2 class="accordion-header">
                                                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#consultation'+histo.declasserId">
                                                                                <span class="fw-bold">{{ formatDate(histo.date_declasser) }} -  {{ histo.service }}</span>
                                                                            </button>
                                                                        </h2>
                                                                        <div v-for="(historique,key) in listHistorique" :key="key">
                                                                            <div :id="'consultation'+histo.declasserId" class="accordion-collapse collapse" v-if="histo.declasserId == historique.dossier_declasser_id">
                                                                                <div class="accordion-body">
                                                                                    <div class="consultation-details">
                                                                                        <div class="detail-section">
                                                                                            <h6>Signes vitaux</h6>
                                                                                            <div v-if="histo.tension || histo.temperature || histo.poids || histo.sucre || histo.taille" class="fst-italic">
                                                                                                <span v-if="histo.groupe_sanguin">&nbsp; <u>Groupe Sanguin</u> : <b>{{ histo.groupe_sanguin }}</b></span>
                                                                                                <span v-if="histo.tension">&nbsp; &nbsp;<u>Tension artérielle</u> : <b>{{ dossiers.tension }} mmHg</b></span>&nbsp;
                                                                                                <span v-if="histo.temperature">&nbsp; &nbsp; <u>Température</u> : <b>{{ dossiers.temperature }} °C</b></span>&nbsp;
                                                                                                <span v-if="histo.poids"> &nbsp; &nbsp;<u>Poids</u> : <b>{{ histo.poids }} kg</b></span>&nbsp;
                                                                                                <span v-if="histo.sucre"> &nbsp; &nbsp;<u>Sucre</u> : <b>{{ histo.sucre }} g/L</b></span>&nbsp;
                                                                                                <span v-if="histo.taille">&nbsp; &nbsp; <u>Taille</u> : <b>{{ histo.taille }} cm</b></span>
                                                                                            </div>
                                                                                            <br>

                                                                                            <h6>Symptomes</h6>
                                                                                            <ul class="">
                                                                                                    <li v-for="(symptome, key) in historique.symptomes" :key="key" class="d-flex justify-content-between align-items-center mb-2 pb-1">
                                                                                                        <span>{{ symptome.contenu }}</span>
                                                                                                    </li>
                                                                                            </ul> <br>
                                                                                            <h6>Remarques</h6>
                                                                                            <ul class="">
                                                                                                    <li v-for="(remarque, key) in historique.remarques" :key="key" class="d-flex justify-content-between align-items-center mb-2  pb-1">
                                                                                                        <span>{{ remarque.remarque }}</span>
                                                                                                    </li>
                                                                                            </ul> <br>
                                                                                            <h6>Notes</h6>
                                                                                            <ul class="">
                                                                                                    <li v-for="(note, key) in historique.notes" :key="key" class="d-flex justify-content-between align-items-center mb-2  pb-1">
                                                                                                        <span>{{ note.note }}</span>
                                                                                                    </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                        <!-- <div class="detail-section">
                                                                                            <h6>Notes</h6>
                                                                                            <ul class="list-unstyled">
                                                                                                    <li v-for="(note, key) in historique.notes" :key="key" class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
                                                                                                        <span>{{ note.note }}</span>
                                                                                                    </li>
                                                                                                </ul>
                                                                                        </div> -->
                                                                                        <div class="detail-section">
                                                                                            <h6>Prescriptions</h6>
                                                                                                <template v-if="historique.prescriptions && historique.prescriptions.length > 0">
                                                                                                    <div class="table-responsive">
                                                                                                        <table class="table table-sm table-bordered align-middle">
                                                                                                        <thead class="table-light">
                                                                                                            <tr>
                                                                                                            <!-- <th>#</th> -->
                                                                                                            <th>Médicament</th>
                                                                                                            <th>Posologie</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            <tr v-for="(medicament, key) in historique.prescriptions" :key="key">
                                                                                                            <!-- <td>{{ key + 1 }}</td> -->
                                                                                                            <td>{{ medicament.medicament }}</td>
                                                                                                            <td>{{ medicament.posologie }}</td>
                                                                                                            </tr>
                                                                                                        </tbody>
                                                                                                        </table>
                                                                                                    </div>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                <p class="text-muted fst-italic">Aucune prescription enregistrée.</p>
                                                                                                </template>

                                                                                            
                                                                                        </div>
                                                                                        <div class="detail-section">
                                                                                            <h6>Examens</h6>

                                                                                            <template v-if="historique.examens && historique.examens.length > 0">
                                                                                                <ul class="list-unstyled">
                                                                                                    <li v-for="(examen, key) in historique.examens" :key="key" class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
                                                                                                        <span>{{ examen.examen }}</span>
                                                                                                        <template v-if="examen.resultats">
                                                                                                            <button style="background-color: #00C853; color: #fff;" @click="lireResultat(examen)" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#modalPreviewResultat">
                                                                                                                📄 Voir résultat
                                                                                                            </button>
                                                                                                        </template>
                                                                                                        <template v-else>
                                                                                                            <button class="btn btn-sm btn-outline-secondary btn-add-result" @click="getInfoforSaveResultat(examen)" data-bs-toggle="modal" data-bs-target="#addResultatExamen">
                                                                                                                <span style="color: #00C853;"><i class="fa fa-plus"></i></span> Ajouter résultat
                                                                                                            </button>
                                                                                                        </template>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </template>

                                                                                            <template v-else>
                                                                                                <p class="text-muted fst-italic">Aucun examen enrégistré</p>
                                                                                            </template>
                                                                                        </div>                                                                                
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                     </div>
                                                                    </div>
                                                                </div>
                                                                
                                                            </template>
                                                            <template v-else>
                                                                <div>
                                                                    Vide
                                                                </div>
                                                            </template>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                               <!-- <div class="tab-pane fade" id="tab3" role="tabpanel"
                                                aria-labelledby="tab3-tab">
                                                    <p>This is the content of Tab 3.</p>
                                                </div>-->
                                                <div :class="['tab-pane', 'fade', 'show','text-center', { 'active': role != 3 || dossiers.declasser !=1 }]" id="tab4"
                                                    role="tabpanel" aria-labelledby="tab4-tab">
                                                    <template v-if="dossiers.code_dossier">
                                                        <div class="row">
                                                            <div class="col-sm-4">
                                                                <p class="mb-0 fw-bold">{{ dossiers.code_dossier }}</p>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0"><span class="mb-0 fw-bold">{{dossiers.nom_patient}} {{dossiers.prenom_patient}}</span></p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <!-- <div class="row">
                                                            <div class="col-sm-4">
                                                                
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0"></p>
                                                            </div>
                                                        </div> -->
                                                        <!-- <hr> -->
                                                        <div class="row">
                                                            <div class="col-sm-4">
                                                                <p class="mb-0 fw-bold">Sexe</p>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0">{{ dossiers.sexe === 1 ? 'Masculin' : 'Féminin' }}</p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-sm-4">
                                                                <p class="mb-0 fw-bold">Date naissance</p>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0">{{dossiers.date_naiss.split('-').reverse().join('-')}}</p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-sm-4">
                                                                <p class="mb-0 fw-bold">Age</p>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0">
                                                                 {{ age.years }} ans{{ age.days > 0 ? ' ' + age.days + ' jour' + (age.days > 1 ? 's' : '') : '' }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-sm-4">
                                                                <p class="mb-0 fw-bold">Adresse</p>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0">{{ dossiers.adresse }}</p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-sm-4 fw-bold">
                                                                <p class="mb-0">Commune</p>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="text-muted mb-0">{{ dossiers.commune }}</p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-sm-4 fw-bold">
                                                                <p class="mb-0">Département</p>
                                                            </div>
                                                            <div class="col-sm-8 fw-bold">
                                                                <p class="text-muted mb-0">{{ dossiers.departement }}</p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                    </template>
                                                    <template v-else>
                                                        <div class="modal-preloader">
                                                            <div class="spinner"></div>
                                                        </div>
                                                    </template>
                                                    
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </DashView>
    <!-- START All Modal -->
            <!-- Modal Add Resultat-->
        <div class="modal fade" id="addResultatExamen" tabindex="-1" aria-labelledby="newSymptomModal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ajouter résultat</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <h5>{{ form_resultat.examen }}</h5>
                        <form id="resultatExam" @submit.prevent="registerResultat">
                            <div class="mb-3">
                                <label for="resultatExam" class="form-label">Résultat (fichier)</label>
                                <input type="file" class="form-control" id="resultatExam" required accept="image/*,.pdf,.jpg,.jpeg,.png" @change="handleFileChange">
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                                <button type="submit" class="btn" style="background:#00C853; color: #fff;" id="addNewSymptomBtn">Ajouter</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL de prévisualisation du document -->
        <div class="modal fade" id="modalPreviewResultat" tabindex="-1" aria-labelledby="modalPreviewLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalPreviewLabel">Aperçu du résultat de l'examen <span class="fw-bold">{{ docUrl_examen }}</span></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                    </div>
                    <div class="modal-body" style="height: 90vh;">
                        <iframe :src="docUrl" width="100%" height="100%" style="border: none;"></iframe>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL de cloturer consultation -->
        <div class="modal fade" id="closeModal" tabindex="-1" aria-labelledby="closeModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="closeModalLabel">Options</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                </div>
                <div class="modal-body">
                    <div class="form-check mb-2">
                        <input class="form-check-input" type="radio" name="closeOption" id="option1" value="withoutFollowup" v-model="closeOption">
                        <label class="form-check-label" for="option1">Classer Dossier</label>
                    </div>

                    <div class="form-check mb-2">
                        <input class="form-check-input" type="radio" name="closeOption" id="option2" value="withFollowup" v-model="closeOption">
                        <label class="form-check-label" for="option2">Fixer un rendez-vous de suivi</label>
                    </div>

                    <!-- Rendez-vous -->
                    <div id="followupForm" class="ps-3" v-if="closeOption === 'withFollowup'">
                        <div class="mb-3">
                            <p v-if="error_msg" class="alert text-center text-info">{{ error_msg }}</p>
                        </div>
                        <div class="mb-3">
                            <label for="followupDate" class="form-label fw-bold">Date du rendez-vous</label>
                            <input type="date" id="followupDate" class="form-control"  v-model = "form_rendezVous.date">
                        </div>
                        <div class="mb-3">
                            <label for="followupTime" class="form-label fw-bold">Heure</label>
                            <input type="time" id="followupTime" class="form-control"  v-model = "form_rendezVous.heure">
                        </div>
                        <div class="mb-3">
                            <label for="service" class="form-label fw-bold">Service</label>
                            <select class="form-control custom-select text-center" v-model="form_rendezVous.service" id="commune_patient" required>
                                <option value="">--Services--</option>
                                <template v-if="services.length > 0">
                                <option v-for="(service,key) in services" :key="key" :value="service.id">{{ service.service }}</option>
                                </template>
                                <template v-else>
                                <option value="">Aucun Service trouvé</option>
                                </template>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="specialiste" class="form-label fw-bold">Spécialiste</label>
                            <select class="form-control text-center" v-model="form_rendezVous.specialite" required>
                                <option value="">--Spécialité--</option>
                                <option v-for="specialite in specialitesPourMedecin" :key="specialite.id" :value="specialite.id">
                                    {{ specialite.specialite }}
                                </option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="docteur" class="form-label fw-bold">Docteur</label>
                            <select class="form-control custom-select text-center disabled" v-model = "form_rendezVous.medecin">
                                <option value="">--Docteurs--</option>
                                <template v-if="medecins.length > 0">
                                <option v-for="(docteur,key) in medecins" :key="key" :value="docteur.id">{{ docteur.nom }} {{ docteur.prenom }}</option>
                                </template>
                                <template v-else>
                                <option value="">Aucun Docteur trouvé</option>
                                </template>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="followupReason" class="form-label fw-bold">Motif du suivi</label>
                            <textarea rows="3" id="followupReason" class="form-control"  v-model = "form_rendezVous.motif"></textarea>
                        </div>
                        <!-- <div class="mb-3">
                            <label for="followupDoctor" class="form-label fw-bold">Médecin/service</label>
                            <select class="form-control select2" ref="selectMedecin"  v-model = "form_rendezVous.medecin">
                                <option value="">--Médecins--</option>
                                <template v-if="medecins.length > 0">
                                <option v-for="(docteur,key) in medecins" :key="key" :value="docteur.utilisateur">{{ docteur.nom_user }} {{ docteur.prenom_user }}</option>
                                </template>
                                <template v-else>
                                <option value="">Aucun Docteur trouvé</option>
                                </template>
                            </select>
                        </div> -->
                    </div>

                    <div class="form-check mb-2">
                        <input class="form-check-input" type="radio" name="closeOption" id="option3" value="redirect" v-model="closeOption">
                        <label class="form-check-label" for="option3">Rediriger vers un autre service</label>
                    </div>

                    <!-- Rediriger vers autre service -->
                    <div class="ps-3" v-if="closeOption === 'redirect'">
                        <div class="mb-3">
                            <label for="service" class="form-label fw-bold">Service</label>
                            <select class="form-control custom-select text-center" v-model="form_declasser.service" id="commune_patient" required>
                                <option value="">--Services--</option>
                                <template v-if="services.length > 0">
                                <option v-for="(service,key) in services" :key="key" :value="service.id">{{ service.service }}</option>
                                </template>
                                <template v-else>
                                <option value="">Aucun Service trouvé</option>
                                </template>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="specialiste" class="form-label fw-bold">Spécialiste</label>
                            <select class="form-control text-center" v-model="form_declasser.specialite" required @change="getDoctorforSpecialite">
                                <option value="">--Spécialité--</option>
                                <template v-if="specialites.length > 0">
                                <option v-for="(specialite,key) in specialites" :key="key" :value="specialite.id">{{specialite.specialite }}</option>
                                </template>
                                <template v-else>
                                <option value="">Aucune Spécialité</option>
                                </template>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="docteur" class="form-label fw-bold">Docteur</label>
                            <select class="form-control custom-select text-center" id="commune_patient" v-model = "form_declasser.docteur">
                                <option value="">--Docteurs--</option>
                                <template v-if="docteurs.length > 0">
                                <option v-for="(docteur,key) in medecinsPourSpecialite" :key="key" :value="docteur.utilisateur">{{ docteur.nom_user }} {{ docteur.prenom_user }}</option>
                                </template>
                                <template v-else>
                                <option value="">Aucun Docteur trouvé</option>
                                </template>
                            </select>
                        </div>
                        <!-- <div class="mb-3">
                            <label for="redirectNote" class="form-label">Note (optionnelle)</label>
                            <textarea id="redirectNote" rows="3" class="form-control"></textarea>
                        </div> -->
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button class="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                    <button class="btn btn-success ms-auto" style="background-color: #00C853; color:#fff;" v-if="closeOption" @click="terminerConsultation">Ok</button>
                </div>
                </div>
            </div>
        </div>
        <!-- Start Modal consultation preliminaires -->
            <!-- The Modal -->
        <div class="modal" id="preliminaire-consul">
            <div class="modal-dialog">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Informations préliminaires</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div id="followupForm" class="ps-3">
                        <!-- <div class="mb-3">
                            <p v-if="error_msg" class="text-white alert text-center text-info">{{ error_msg }}</p>
                        </div> -->
                        <div class="mb-3">
                            <label for="tension" class="form-label fw-bold">Tension</label>
                            <input type="text" id="tension" class="form-control"  v-model = "preliminaire.tension">
                        </div>
                        <div class="mb-3">
                            <label for="poids" class="form-label fw-bold">Poids</label>
                            <input type="text" id="poids" class="form-control"  v-model = "preliminaire.poids">
                        </div>
                        <div class="mb-3">
                            <label for="taille" class="form-label fw-bold">Taille</label>
                            <input type="text" id="taille" class="form-control"  v-model = "preliminaire.taille">
                        </div>
                        <div class="mb-3">
                            <label for="sucre" class="form-label fw-bold">Taux du Sucre</label>
                            <input type="text" id="sucre" class="form-control"  v-model = "preliminaire.sucre">
                        </div>
                        <div class="mb-3">
                            <label for="temperature" class="form-label fw-bold">Température</label>
                            <input type="text" id="temperature" class="form-control"  v-model = "preliminaire.temperature">
                        </div>
                        <div class="mb-3">
                            <label for="commentaire" class="form-label fw-bold">Commentaire</label>
                            <textarea rows="3" id="commentaire" class="form-control"  v-model = "preliminaire.commentaire"></textarea>
                        </div>
                        
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger " data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-success ms-auto" @click="registerPreliminaire">Save</button>
                </div>


                </div>
            </div>
        </div>
        <!-- END Modal consultation preliminaires -->
         


</template>
<script>
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import $ from 'jquery';
import axios from 'axios'
const base_url=process.env.VUE_APP_API_URL;
import DashView from "@/components/DashView.vue"
export default {
    name:"ConsultationDossier",
    components:{
        DashView
    },
    data(){
        return{          
          dossiers:[],
          docteurs:[],
          medecins:[],
          services:[],
          specialites:[],
          docUrl:null,
          declasser_id:'',
          selectedSpecialite:'',
          docUrl_examen:null,
          success_msg:'',
          error_msg:'',
          validationErrors:[],
          role:JSON.parse(localStorage.getItem('user_zgh')).code_role ?? '',
          doc:JSON.parse(localStorage.getItem('user_zgh')).id ?? '',
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          dossier: this.$route.params.dossier,
          panier_prescription:JSON.parse(localStorage.getItem('panier_zgh'))?.prescriptions??[],
          panier_examen:JSON.parse(localStorage.getItem('panier_zgh'))?.examens??[],
          panier_symptome:JSON.parse(localStorage.getItem('panier_zgh'))?.symptomes??[],
          panier_note:JSON.parse(localStorage.getItem('panier_zgh'))?.notes??[],
          panier_remarque:JSON.parse(localStorage.getItem('panier_zgh'))?.remarques??[],
          panier:JSON.parse(localStorage.getItem('panier_zgh'))??[],
          historiques:[],
          form:{
            consultation:{
                remarque:JSON.parse(localStorage.getItem('panier_zgh'))?.consultation?.remarque??null,
                note:JSON.parse(localStorage.getItem('panier_zgh'))?.consultation?.note??null,
            },
            prescription:{
                medicament:null,
                posologie:null
            },
            examen:{
                nom:null
            },
            symptome:{
                contenu:null
            }
          },
          listHistorique:[],
          form_resultat:{
                selectedFile:null,
                consultation_id:null,
                examen_id:null,
                examen:null                
            },
          closeOption: '',
            form_declasser:{
                service:'',
                specialite:'',
                docteur:''
            },
            form_rendezVous:{
                date:'',
                heure:'',
                medecin:JSON.parse(localStorage.getItem('user_zgh')).id ?? '',
                motif:'',
                specialite:'',
                service:''
            },
            validationErrors:[],
            preliminaire:{
            tension:'',
            poids:'',
            taille:'',
            temperature:'',
            sucre:'',
            id_declasser:'',
            commentaire:'',
          }
        }
    },
    created(){
        axios.get(`${base_url}/getInfoDossier?dossier=${this.dossier}`, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${this.accessToken}`
            }
            })
              .then((response)=>{
                    // console.log('Info dossier!');
                    //console.log(this.panier_prescription);
                    console.log('Dossiers!!');
                    
                    console.log(response.data);
                  if(response.status==200){
                        this.dossiers = response?.data?.filter((element)=>element.declasser==1)[0]?? response?.data[response.data.length-1];
                        this.declasser_id = this.dossiers?.declasser_id;
                        this.preliminaire.id_declasser= this.dossiers?.declasser_id;
                        // console.log('this dossier');
                        // console.log(this.dossiers);     
                    }                
              })
              .catch((error)=>{
                  if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                }
                //   console.error(error);
              });
    },
    methods:{
        formatDate(dateString) {
              const date = new Date(dateString);
              const day = ('0' + date.getDate()).slice(-2);
              const month = ('0' + (date.getMonth() + 1)).slice(-2);
              const year = date.getFullYear();
              const hours = ('0' + date.getHours()).slice(-2);
              const minutes = ('0' + date.getMinutes()).slice(-2);
              const seconds = ('0' + date.getSeconds()).slice(-2);
  
              return `${day}-${month}-${year}`;
        },
        onSelectsChange() {          
            console.log('Change data');
            this.form_declasser.specialist = this.selectedSpecialite;
            console.log('Spécialité sélectionnée:', this.selectedSpecialite);
        },
        registerDeclassement(){
            console.log('Form Declasser');
            this.success_msg='';
            const control = !!(this.declasserPatient.code_dossier && this.form_declasser.service && this.form_declasser.specialite);
            if(control){
                const $data = {
                    dossier: this.declasserPatient.code_dossier,
                    service : this.form_declasser.service,
                    service_name: this.services.filter(element=>element.id==this.form_declasser.service)[0].service,
                    specialite:this.form_declasser.specialite,
                    docteur: this.form_declasser.doctor
                };
                console.log($data);
                // return false;

                axios.post(`${base_url}/declasser_dossier`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Dossier déclassé avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }
        },
        registerConsultation(){
            // console.log('registerConsultation');
            const panier = localStorage.getItem('panier_zgh');
            if(panier){
                const consultation = JSON.parse(localStorage.getItem('panier_zgh'))?.consultation??{};
                const prescription = JSON.parse(localStorage.getItem('panier_zgh'))?.prescriptions??[];
                const examen = JSON.parse(localStorage.getItem('panier_zgh'))?.examens??[];
                const symptomes = JSON.parse(localStorage.getItem('panier_zgh'))?.symptomes??[];
                // console.log(symptomes.length);
                // console.log(Object.keys(consultation).length);
                
                
                // const control = !!(Object.keys(consultation).length==4);
                const control = true;
                if(control){
                    const $data ={
                            patient : this.dossier,
                            docteur : this.doc,
                            declasser_id:this.declasser_id,
                            note:  JSON.parse(localStorage.getItem('panier_zgh'))?.notes,
                            remarque : JSON.parse(localStorage.getItem('panier_zgh'))?.remarques,
                            prescription : JSON.parse(localStorage.getItem('panier_zgh'))?.prescriptions,
                            examen : JSON.parse(localStorage.getItem('panier_zgh'))?.examens,
                            symptomes : JSON.parse(localStorage.getItem('panier_zgh'))?.symptomes,
                        };
                        console.log('ok Data');
                        // console.log($data);

                        //  return false;
                        
                        axios.post(`${base_url}/save_consultation`,$data,{
                            headers:{
                                Accept:'application/json',
                                'Content-Type':'application/json;charset=UTF-8',
                                Authorization:`Bearer ${this.accessToken}`
                            }
                        })
                    .then((response)=>{
                        console.log(response.data);
                        if(response.status==201){
                            this.success_msg = `Consultation enrégistrée avec success!`;
                            this.$store.commit('removePanierZgh');
                            setTimeout(function() {
                                location.reload();
                            },2000);
                            // this.cancelConsultation();
                        }
                        else{
                            console.log('Erreur!!!');
                        }
                    })
                    .catch((error)=>{
                        // console.log(error);
                        if (error?.response?.status === 401) {
                                console.log('error');
                                const error_msg = error.response.data.errors;
                                
                                console.log(error_msg);
                                this.displayValidationErrors(error.response.data.errors); 
                                this.$store.commit('removePanierZgh');                      
                        } 
                        else if(error?.response?.status === 403){
                            console.log('NO access');
                            $('#closeModalAddAssurance').trigger('click');
                            $('#openModalNoAccess').trigger('click');
                        }
                        else {
                        // Gérer d'autres erreurs ici
                        console.log('Autre erreur:', error);
                        this.$store.commit('removePanierZgh');
                        }
                    })
                }
            }
           
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        addPrescriptionInCart() {
            const medicament = this.form.prescription.medicament;
            const posologie = this.form.prescription.posologie;

            if (medicament && posologie) {
                const prescription = {
                    medicament: medicament,
                    posologie: posologie
                };
                this.addToCart(prescription, 'prescription');
                // Réinitialisez les champs
                this.form.prescription.medicament = null;
                this.form.prescription.posologie = null;
                this.panier_prescription=JSON.parse(localStorage.getItem('panier_zgh'))?.prescriptions??[];
            } 
            else {
                // this.validationErrors.push('Veuillez remplir tous les champs de prescription.');
            }
        },
        addExamenInCart() {
            const nom = this.form.examen.nom;

            if (nom) {
                const examen = {
                    nom: nom
                };
                this.addToCart(examen, 'examen');
                // Réinitialisez les champs
                this.form.examen.nom = null;
                this.panier_examen=JSON.parse(localStorage.getItem('panier_zgh')).examens??[];
            } 
            else {
                this.validationErrors.push('Veuillez remplir le champs d\'examen.');
            }
        },
        addSymptomeInCart() {
            const contenu = this.form.symptome.contenu; 

            console.log(contenu);
            
            if (contenu) {
                const symptome = {
                    contenu: this.form.symptome.contenu
                };
                console.log(symptome);
                
                this.addToCart(symptome, 'symptome');
                // Réinitialisez les champs
                this.form.symptome.contenu = null;
                this.panier_symptome=JSON.parse(localStorage.getItem('panier_zgh')).symptomes??[];
                this.loadPanierFromLocalStorage();
            } 
            else {
                this.validationErrors.push('Veuillez remplir tous les champs de symptome.');
            }
        },
        addNoteInCart(){
            if(this.form.consultation.note){
                const note ={
                    patient:this.dossier,
                    note:this.form.consultation.note
                }
                this.addToCart(note,'notes');
            }
        },
        addRemarqueInCart() {
            const consultation ={
                    patient:this.dossier,
                    docteur:1,
                    // remarque:this.form.consultation.remarque,
                    // note:this.form.consultation.note
                }
                // this.addToCart(consultation);
            if (this.form.consultation.remarque) {
                this.addToCart({
                    patient: this.dossier, // facultatif si déjà présent
                    remarque: this.form.consultation.remarque,
                },'remarques');
                this.form.consultation.remarque='';
            }
        },
        addConsultationInCart(){
            // if(this.form.consultation.remarque && this.form.consultation.note){
                const consultation ={
                    patient:this.dossier,
                    docteur:1,
                    // remarque:this.form.consultation.remarque,
                    // note:this.form.consultation.note
                }
                this.addToCart(consultation);
            // }
        },
        addToCart(donnee, type=null) {
            // Récupérer le panier existant ou créer un nouveau panier
            const panier = JSON.parse(localStorage.getItem('panier_zgh')) || {
                consultation: {},
                prescriptions: [],
                examens: [],
                symptomes:[],
                notes:[],
                remarques:[]
            };

            // Ajouter les données dans le bon type
            if (type === 'prescription') {
                panier.prescriptions.push(donnee);
            } 
            else if (type === 'examen') {
                panier.examens.push(donnee);
            }
            else if (type === 'symptome') {
                panier.symptomes.push(donnee);
                this.form.symptome.contenu='';
            }
            else if (type === 'notes') {
                panier.notes.push(donnee);
                this.form.consultation.note='';
            }
            else if (type === 'remarques') {
                panier.remarques.push(donnee);
                this.form.consultation.remarque='';
            }
            else {
                panier.consultation = {
                    ...panier.consultation,
                    ...donnee
                };
            }


            // Mettre à jour le localStorage
            // localStorage.setItem('panier_zgh', JSON.stringify(panier));
            this.$store.commit('setPanier', panier);

            // Afficher un message de succès
            this.success_msg = 'Données ajoutées avec succès!';
            const self=this;
            setTimeout(function() {
               self.success_msg='';
            },2000);
            this.loadPanierFromLocalStorage();
        },
        removeFromCart(type, index) {
            console.log([type,index]);
            const panier = JSON.parse(localStorage.getItem('panier_zgh'));
            // panier.symptomes.splice(index, 1);
            if (panier) {
                if (type === 'prescription') {
                    panier.prescriptions.splice(index, 1);
                } 
                else if (type === 'examen') {
                    panier.examens.splice(index, 1);
                } 
                else if (type === 'symptomes') {
                    panier.symptomes.splice(index, 1);
                } 
                else if (type === 'notes') {
                    panier.notes.splice(index, 1);
                } 
                else if (type === 'remarques') {
                    panier.remarques.splice(index, 1);
                } 

                // localStorage.setItem('panier_zgh', JSON.stringify(panier));
                this.$store.commit('setPanier', panier);
                
                // Recharger les valeurs après mise à jour
                this.loadPanierFromLocalStorage(); 
                
                
                // Afficher un message de succès
                this.success_msg = 'Élément supprimé avec succès!';
                const self=this;
                setTimeout(function() {
                    self.success_msg='';
                },2000);
                this.loadPanierFromLocalStorage();
            }
        },
        loadPanierFromLocalStorage() {
            const panier = JSON.parse(localStorage.getItem('panier_zgh')) || {};
            this.panier_prescription = panier.prescriptions || [];
            this.panier_examen = panier.examens || [];
            this.panier_symptome = panier.symptomes || [];
            this.panier_note = panier.notes || [];
            this.panier_remarque = panier.remarques || [];
        },
        loadHistoriqueConsultation(){
            if(this.listHistorique.length==0){
                this.getHistoriqueConsultation();
            }
        },
        getHistoriqueConsultation(){
            axios.get(`${base_url}/consultations?patient=${this.dossier}`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
              .then((response)=>{
                console.log('Historiques');
                
                  console.log(response.data);
                  if(response.status==200){
                      this.listHistorique = response.data.consultations;
                  }   
                //   console.log(this.listHistorique);
                //   console.log(this.listHistorique.length);
                  
                               
              })
              .catch((error)=>{
                  if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                        // Gérer d'autres erreurs ici
                        console.log('Une erreur est survenue!');
                        console.log('Autre erreur:', error);
                    }
                  console.error(error);
              });
        },
        confirmerPriseDeMain() {            
            const url = `${base_url}/accepter_dossier`;
            if(this.dossiers?.code_dossier){            
                const $donnees = {
                    // docteur: this.docteurId,
                    dossier: this.dossiers?.code_dossier
                };
                axios.put(url,$donnees,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response) => {
                    console.log("✅ Succès !");
                    console.log(response.data.success);
                    
                    if(response.data.success){
                        setTimeout(function() {
                            location.reload();
                        },1);
                    }
                })
                .catch(error => {
                console.error("❌ Erreur lors de la mise à jour :", error);
                });
            }
        },
        cancelConsultation(){
            const consult = JSON.parse(localStorage.getItem('panier_zgh'))?.consultation??{};
            const controlConsultation = !!(Object.keys(consult).length==4);
            if(controlConsultation){
                this.$store.commit('removePanierZgh');
            } 
            this.$router.push('/dossier-declasser');           
        },
        handleFileChange(event){           
            const files = event.target.files;
            if(files && files.length>0){
                // this.error = '';
                //! Document Selected
                this.form_resultat.selectedFile = files[0];

                //! Url temporaire doc selected
                // this.docUrl = URL.createObjectURL(this.form.selectedFile);
            }
        },
        registerResultat(){
            console.log('Register Resultat');
            
            // // this.error='';
            // if(!this.form.selectedFile){
            //     // this.error = 'Aucun fichier selectionné';
            // }
            try {
                const data={
                    file:this.form_resultat.selectedFile,
                    consultation:this.form_resultat.consultation_id,
                    examen:this.form_resultat.examen_id
                }

                console.log(data);
                axios.post(`${base_url}/add_resultat`,data,{
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Accept:'application/json',
                        Authorization:`Bearer ${this.accessToken}`
                    },
                })
                .then(response=>{
                    console.log(response.data);
                    if(response?.status==201){
                        this.success_msg = `Document ajouté avec succès!`;
                        let self = this;
                        setTimeout(function() {
                                // self.$router.push('/group-all');
                              location.reload();
                            },2000);
                    }
                    else{
                        console.log('Un erreur est survenu');
                    }
                })
                .catch(error=>{
                   if (error?.response?.status === 401) {
                        this.displayValidationErrors(error.response.data.errors);                       
                } 
                else if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                }
                });
            } 
            catch (error) {
                this.error = "Erreur lors de l'extraction du texte";
            }
        },
        getInfoforSaveResultat(data){
            this.form_resultat.examen_id = null;
            this.form_resultat.examen = null;
            this.form_resultat.consultation_id = null;
            if(data.id){
                this.form_resultat.examen_id = data.id;
                this.form_resultat.examen = data.examen;
                this.form_resultat.consultation_id = data.consultation_id
            }            
        },
        lireResultat(donnee){
            // console.log(donnee);
            const baseURL = base_url.replace('/api', '');
            this.docUrl = `${baseURL}/${donnee.resultats}`; 
            this.docUrl_examen = donnee.examen;       
        },
        getSpecialites(){
            axios.get(`${base_url}/specialites`,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('specialite');
                    // console.log(response?.data);
                    if(response?.status==200){
                        this.specialites = response.data;
                        
                        console.log(response?.data);
                        if(response?.data?.length>0){

                            this.specialites = response.data;
                        }
                        // console.log(this.roles);
                    }                
                })
                .catch((error)=>{
                    console.log('Une erreur est survenue!');
                    console.error(error);
                });
        },
        getDoctorforSpecialite(){
            this.form_declasser.doctor='';
            this.docteurs=[];
            if(this.form_declasser.specialite){
                axios.get(`${base_url}/getDoctors?specialite=${this.form_declasser.specialite}`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        // console.log(response?.data);
                        if(response?.status==200){
                            // console.log(response?.data);
                            if(response?.data?.length>0){
                                this.docteurs = response.data.filter(element => {
                                    if (!element.specialite_ids) return false;
                                    const ids = element.specialite_ids.split(',');
                                    return ids.includes(this.form_declasser.specialite.toString());
                                });
                            }
                        }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
            }
        },
        getServices(){
                axios.get(`${base_url}/services`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log('services');
                        console.log(response?.data);
                        // if(response?.status==200){
                        //     if(response?.data?.services.length>0){
                                this.services = response?.data?.services;
                                
                                console.log('this.services');
                                console.log(this.services);
                                
                        //     }
                        // }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
        },
        initializeSelect2(refName, modelKey) {
            const $select = $(this.$refs[refName]);
            $select
                .select2({ placeholder: `Sélectionnez un ${modelKey}`, width: '100%',dropdownCssClass: "form-control" })
                .on('change', () => {
                this.form_rendezVous[modelKey] = $select.val();
            });
        },
        // Rafraîchit les options du select2 après changement de données
        refreshSelect2(refName, modelKey) {
            this.$nextTick(() => {
                const $select = $(this.$refs[refName]);
                $select.off('change').select2('destroy');
                this.initializeSelect2(refName, modelKey);
                $select.val(this.form_rendezVous[modelKey]).trigger('change');
            });
        },
        getDoctors(){
            console.log('GetDoctors');
            
            this.form_declasser.doctor='';
            this.medecins=[];
            // if(this.form_declasser.specialite){
                axios.get(`${base_url}/getDoctors`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log('Medecins');
                        console.log(response?.data.docteurs);
                        if(response?.status==200){                            
                            // console.log(response?.data);
                            if(response?.data?.docteurs.length>0){
                                this.medecins = response.data.docteurs;
                            }
                        }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
            // }
        },
        terminerConsultation(){
            switch (this.closeOption) {
                case 'withFollowup':
                    this.cloturerAvecRendezVous();
                    break;
                case 'redirect':
                    this.redirigerConsultation();
                    break;
                case 'withoutFollowup':
                    this.cloturerSimplement();
                    break;
                default:
                    alert("Veuillez choisir une option de clôture.");
            }
        },
        cloturerSimplement(){
          const $data ={
              dossier:this.dossier
            };
          axios.put(`${base_url}/fermer_consultation`,$data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
          .then((response)=>{
              console.log(response.data);
              if(response?.status==200){
                  this.success_msg = `Consultation Fermé!`;
                  let self = this;
                  self.$router.push('/dossier-declasser');
                  setTimeout(function() {
                        location.reload();
                    },100);
              }
              else{
                console.log('Un erreur est survenu');
              }
          })
          .catch((error)=>{
              if (error?.response?.status === 401) {
                        this.displayValidationErrors(error.response.data.errors);                       
                } 
                else if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                }
          })
        },
        displayValidationErrors(errors) {
            // Remplacer les erreurs actuelles par les nouvelles
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 2 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 2000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        redirigerConsultation(){
            console.log('Rediriger');
            
            this.success_msg = '';
            this.error_msg='';
            console.log(this.form_declasser);
            
            const { service, specialite, docteur} = this.form_declasser;
            const tousChampsOK = !!(service && specialite && docteur);
            if(tousChampsOK){
                this.cloturerSimplement();
                    const $data = {
                        service:service,
                        specialite:specialite,
                        docteur:docteur,
                        dossier:this.dossier
                    };
                    console.log($data);
                    
                    axios.post(`${base_url}/declasser_dossier`,$data,{
                        headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                    console.log(response.data);
                    if(response?.status==200){
                        this.success_msg = `Info enrégistré!`;
                        let self = this;
                        self.$router.push('/dossier-declasser');
                        setTimeout(function() {
                                location.reload();
                            },100);
                    }
                    else{
                        console.log('Un erreur est survenu');
                    }
                })
                .catch((error)=>{
                    if (error?.response?.status === 401) {
                                this.displayValidationErrors(error.response.data.errors);                       
                        } 
                        else if(error?.response?.status === 403){
                            console.log('NO access');
                            $('#openModalNoAccess').trigger('click');
                        }
                        else {
                            // Gérer d'autres erreurs ici
                            console.log('Autre erreur:', error);
                        }
                })
        
            }
            else{
                this.error_msg = `Veuillez remplir tous les champs obligatoires.`;
                setTimeout(()=> {
                    this.error_msg='';
                },1500);
                return;
            }
        },
        cloturerAvecRendezVous(){
            this.success_msg = '';
            this.error_msg='';
            const { date, heure, medecin, motif, specialite, service } = this.form_rendezVous;
            const tousChampsOK = !!(date && heure && motif && specialite && service);
            if(tousChampsOK){
                    const $data ={
                        date:date,
                        heure:heure,
                        medecin:this.form_rendezVous.medecin,
                        motif:motif,
                        specialite:specialite,
                        service:service,
                        dossier:this.dossier
                    };

                    // console.log($data);
                    // return false;
                    
                    axios.post(`${base_url}/save_rendez_vous`,$data,{
                        headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                    // console.log(response.data);
                    if(response?.status==200){
                        this.success_msg = `Rendez-vous enrégistré avec succès!S!`;
                        let self = this;
                        self.$router.push('/dossier-declasser');
                        setTimeout(function() {
                                location.reload();
                            },100);
                    }
                    else{
                        console.log('Un erreur est survenu');
                    }
                })
                .catch((error)=>{
                    if (error?.response?.status === 401) {
                                this.displayValidationErrors(error.response.data.errors);                       
                        } 
                        else if(error?.response?.status === 403){
                            console.log('NO access');
                            $('#openModalNoAccess').trigger('click');
                        }
                        else {
                            // Gérer d'autres erreurs ici
                            console.log('Autre erreur:', error);
                        }
                })
        
            }
            else{
                this.error_msg = `Veuillez remplir tous les champs!!`;
                setTimeout(()=> {
                    this.error_msg='';
                },5000);
                return;
            }
        },
        initJsPrintManager(){
          // Initialisation de JSPrintManager
          JSPM.JSPrintManager.start();
          JSPM.JSPrintManager.WS.onStatusChanged = function () {
            if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
              console.log("JSPrintManager est prêt !");
            } else {
              console.error("JSPrintManager n'est pas connecté.");
            }
          };
        },
        getIdDeclasser(data){
            console.log(data);            
           this.preliminaire.id_declasser =  data.id_declasser;
           this.info.nom = data.nom_patient;
           this.info.prenom = data.prenom_patient;
           this.info.dossier = data.code_dossier;
        },
        registerPreliminaire(){
            const $data={
                declasser_id: this.preliminaire.id_declasser,
                tension: this.preliminaire.tension,
                taille : this.preliminaire.taille,
                poids: this.preliminaire.poids,
                sucre: this.preliminaire.sucre,
                temperature : this.preliminaire.temperature,
                description: this.preliminaire.commentaire
                
            }
            console.log($data);
            
            // if($data){
            //     console.log($data);
            // }

            axios.post(`${base_url}/add-info-preliminaire`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Apres prelimi...');
                    
                    console.log(response.data);
                    if(response.status==200){
                        this.success_msg = `Données ajoutées avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                     // Gérer d'autres erreurs ici
                     console.log('Autre erreur:', error);
                    }
                })            
            
        },
        getIdDeclasser(id){
            console.log(id);            
           this.preliminaire.id_declasser =  id;
        },
        getDossierPatient(){
            axios.get(`${base_url}/get_dossier?dossier=${this.dossier}`, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${this.accessToken}`
            }
            })
              .then((response)=>{
                    console.log('Get Dossier Patient!');
                    console.log(response.data);
                    this.historiques = response.data.historiques;
             
              })
              .catch((error)=>{
                  if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                }
                //   console.error(error);
              });
        }
     
  },
  mounted(){
        //! Pour initialiser le module JSPrintManager
        // this.initJsPrintManager();

        this.loadHistoriqueConsultation();
        this.getSpecialites();
        this.getDoctors();
        this.getServices();
        this.getDossierPatient();
        
        // this.initializeSelect2('selectMedecin', 'medecin');
    },
    computed: {
        age_old() {
                if (!this.dossiers.date_naiss) {
                    return { years: 0, days: 0 };
                }

            const birthDate = new Date(this.dossiers.date_naiss); //date Naissance
            const currentDate = new Date(); // date courante
            const birthYear = birthDate.getFullYear(); // On prend l'annee de naissance
            const currentYear = currentDate.getFullYear(); // on prend l'annee de la date courante

            let years = currentYear - birthYear; // difference entre les deux annees prises

            /**
             * Calculer le prochain anniversaire
             * new Date prend en parametre : trois parametres pour former la date de naissance de l'
             * annee courante
             *  */ 
            const nextBirthday = new Date(currentYear, birthDate.getMonth(), birthDate.getDate());

            let daysDifference;

            if (currentDate < nextBirthday) {
                years--;
                daysDifference = Math.floor((currentDate - new Date(currentYear - 1, birthDate.getMonth(), birthDate.getDate())) / (1000 * 60 * 60 * 24));
            }
            else {
                daysDifference = Math.floor((currentDate - nextBirthday) / (1000 * 60 * 60 * 24));
            }

            return { years, days: daysDifference };
        },
      age_() {
            if (!this.dossiers.date_naiss) {
                return { years: 0, days: 0 };
            }

            const birthDate = new Date(this.dossiers.date_naiss);
            const today = new Date();
            
            // Créer manuellement des dates sans heures (toujours à minuit)
            const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const birthDateOnly = new Date(birthDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
            const thisYearBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());

            let years = today.getFullYear() - birthDate.getFullYear();
            let days = 0;

            if (todayDateOnly < thisYearBirthday) {
                years--;
                const lastBirthday = new Date(today.getFullYear() - 1, birthDate.getMonth(), birthDate.getDate());
                days = Math.floor((todayDateOnly - lastBirthday) / (1000 * 60 * 60 * 24));
            } else {
                days = Math.floor((todayDateOnly - thisYearBirthday) / (1000 * 60 * 60 * 24));
            }

            console.log({ years, days });
            return { years, days };
            
        },
        age() {
            if (!this.dossiers.date_naiss) {
                return { years: 0, days: 0 };
            }

            // Extraire AAAA, MM, JJ de la date de naissance
            const [year, month, day] = this.dossiers.date_naiss.split('-').map(Number);

            // Créer les dates en UTC uniquement
            const birthUTC = Date.UTC(year, month - 1, day); // Mois - 1 car Janvier = 0
            const today = new Date();
            const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

            // Anniversaire cette année
            const birthdayThisYearUTC = Date.UTC(today.getFullYear(), month - 1, day);

            let years = today.getFullYear() - year;
            let days = 0;

            if (todayUTC < birthdayThisYearUTC) {
                years--;
                const lastBirthdayUTC = Date.UTC(today.getFullYear() - 1, month - 1, day);
                days = Math.floor((todayUTC - lastBirthdayUTC) / (1000 * 60 * 60 * 24));
            } else {
                days = Math.floor((todayUTC - birthdayThisYearUTC) / (1000 * 60 * 60 * 24));
            }
        console.log({ years, days });
        
            return { years, days };
        },  

        specialitesPourMedecin() {
            const medecin = this.medecins.find(m => m.id === this.form_rendezVous.medecin);
            console.log('specialitesPourMedecinok');
            console.log('medecin');
            console.log(medecin);
            
        
            if (!medecin || !medecin.specialites) {
            return this.specialites;
            }

            console.log(medecin);
            const ids = medecin.specialites.map(s => s.specialite_id);
            console.log('ids');
            
            console.log(ids);
            
            const data = this.specialites.filter(s => ids.includes(s.id));
            console.log("Spécialités filtrées :", data);
            return data;
            

        },
        medecinsPourSpecialite() {
    const specialiteId = this.form_rendezVous.specialite;

    if (!specialiteId) {
        return this.medecins;
    }

    const medecinsFiltres = this.medecins.filter(medecin =>
        medecin.specialites &&
        medecin.specialites.some(s => s.specialite_id === specialiteId)
    );

    console.log("Médecins filtrés :", medecinsFiltres);
    console.log(medecinsFiltres);
    
    return medecinsFiltres;
}

    },
}
</script>
<style scoped>
      .badge-hover-close {
      position: relative;
      display: inline-block;
      padding-right: 1.5rem; /* room for the close icon */
      /* color:#dc3545; */
    }

    .badge-hover-close .btn-close {
      position: absolute;
      top: 0;
      right: 0.25rem;
      padding: 0.25rem;
      font-size: 0.5rem;
      display: none;
      
    }

    .badge-hover-close:hover .btn-close {
      display: inline-block;
      /* color:#dc3545; */
    }
	/* Override Bootstrap's link active state styles */
    .nav-link {
        color: #00C853 !important;
    
        }	 
    .nav-link.active{
        color: #00C853 !important;
        background-color: #fff !important;
    }
    .custom-btn-outline {
        background: transparent;
        color: #00C853;
        border: 1px solid #00C853;
    }

    .custom-btn-outline:hover {
        color: #fff;
        background-color: #00C853;
    }
    .severity-indicator {
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 50%;
        margin-right: 5px;
    }

    .severity-low { background-color: #28a745; }
    .severity-medium { background-color: #ffc107; }
    .severity-high { background-color: #dc3545; }

    .card {
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .card-header {
        background-color: #f8f9fa;
        border-bottom: 2px solid #e9ecef;
    }

    .nav-tabs .nav-link.active {
        font-weight: bold;
        border-bottom: 3px solid #00C853;
    }

    .consultation-card {
        transition: transform 0.2s;
        cursor: pointer;
    }

    .consultation-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }

    .symptom-tag {
        margin: 2px;
        padding: 5px 10px;
        background-color: #e9ecef;
        border-radius: 15px;
        display: inline-block;
    }

    .selected-symptoms {
        margin-top: 10px;
    }

    .selected-symptom {
        background-color: #e9ecef;
        padding: 5px 10px;
        margin: 2px;
        border-radius: 15px;
        display: inline-block;
    }
    .accordion-button:not(.collapsed) {
        background-color: #e7f1ff;
        color: #00C853;
    }

    .consultation-details {
        display: grid;
        gap: 1rem;
    }

    .detail-section {
        background-color: #f8f9fa;
        padding: 1rem;
        border-radius: 0.25rem;
    }

    .detail-section h6 {
        color: #00C853;
        margin-bottom: 0.5rem;
    }

    .remove-icon {
        margin-left: 15px; /* Ajustez la valeur en fonction de l'espacement souhaité */
        cursor: pointer;
    }
    .custom-alert {
        background-color: #00C853;
    }
    .btn-add-result {
        color: #00C853;
        border-color: #00C853;
    }

    .btn-add-result:hover {
        background-color: #00C853;
        color: white;
    }

    .select2-container .select2-selection--single{
    height:34px !important;
}
.select2-container--default .select2-selection--single{
         border: 1px solid #ccc !important; 
     border-radius: 0px !important; 
}
.removefont{
    font-weight: normal !important;
}
</style>